<app-breadcrumb [master]="'Administracja'" [parentName]="'Licencje'" [name]="'Urządzenia'"></app-breadcrumb>
<div fxLayout="column" fxLayoutGap="15px" class="list-container">
  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="list-filters">
    <app-dynamic-dict class="list-filter"
                      [multiple]="false"
                      [dictType]="DYNAMIC_DICTIONARY_DEVICE_TYPE"
                      [label]="'Rodzaj urządzenia'"
                      [(ngModel)]="initialFilters.typeOfDevice" name="typeOfDevice">
    </app-dynamic-dict>

    <mat-form-field class="list-filter">
      <mat-label>Nazwa urządzenia</mat-label>
      <input matInput placeholder="Nazwa" name="contains$name" [(ngModel)]="initialFilters.contains$name">
    </mat-form-field>

    <mat-form-field class="list-filter">
      <mat-label>Użytkownik</mat-label>
      <input matInput placeholder="Jan Kowalski" name="username" [(ngModel)]="initialFilters.username">
    </mat-form-field>

    <mat-form-field class="list-filter">
      <mat-label>Numer seryjny</mat-label>
      <input matInput name="contains$serialNumber" [(ngModel)]="initialFilters.contains$serialNumber">
    </mat-form-field>

    <mat-form-field class="list-filter">
      <mat-label>Numer wewnętrzny</mat-label>
      <input matInput name="contains$extensionNumber" [(ngModel)]="initialFilters.contains$extensionNumber">
    </mat-form-field>
  </form>

    <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="space-between center">
        <div>
            <button *ngIf="(userPermissions | async).license.write"  (click)="addDevice()" mat-stroked-button color="primary">
              <mat-icon>add</mat-icon> <span> Dodaj </span>
            </button>
        </div>

        <div fxLayout="row" fxLayoutGap="15px">
          <button *ngIf="(userPermissions | async).license.read_report" (click)="downloadReport()"
                  mat-raised-button class="report-button"><mat-icon>download</mat-icon> <span> Pobierz raport</span>
          </button>
          <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
          <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
        </div>
   </div>

  <table mat-table [dataSource]="dataSource">

    <ng-container matColumnDef="typeOfDevice">
      <th mat-header-cell *matHeaderCellDef> Rodzaj  </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="!disableLinks">
          <a class="default-link" [routerLink]="['/licencje/urzadzenia/szczegoly', element.uuid]">{{element.typeOfDevice.name}}</a>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef> Nazwa </th>
      <td mat-cell *matCellDef="let element">
        {{ element?.name}}
      </td>
    </ng-container>

    <ng-container matColumnDef="serialNumber">
      <th mat-header-cell *matHeaderCellDef> Numer seryjny </th>
      <td mat-cell *matCellDef="let element">
        {{ element?.serialNumber}}
      </td>
    </ng-container>

    <ng-container matColumnDef="extensionNumber">
      <th mat-header-cell *matHeaderCellDef> Numer wewnętrzny </th>
      <td mat-cell *matCellDef="let element">
        {{ element?.extensionNumber}}
      </td>
    </ng-container>

    <ng-container matColumnDef="note">
      <th mat-header-cell *matHeaderCellDef> Notatka </th>
      <td mat-cell *matCellDef="let element"> {{element.note}} </td>
    </ng-container>

    <ng-container matColumnDef="user">
      <th mat-header-cell *matHeaderCellDef> Użytkownik </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element.user">
          <a class="default-link" [routerLink]="['/licencje/uzytkownicy/szczegoly', element.user.uuid]">{{element.user.firstName +' '+ element.user.lastName}}</a>
        </ng-container>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>
